import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "@emotion/react/jsx-runtime";
import { Fragment, useMemo, useEffect, useState } from 'react';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemText from '@mui/material/ListItemText';
import ListItemAvatar from '@mui/material/ListItemAvatar';
import Avatar from '@mui/material/Avatar';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Chip from '@mui/material/Chip';
import Radio from '@mui/material/Radio';
import { useMediaQuery, useTheme } from "@mui/material";
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import TableRowsIcon from '@mui/icons-material/TableRows';
import { useFlow } from "../../context/FlowContext";
import { useI18N } from '../../context/I18NContext';
import useWidgetStore from '../../store/useWidgetStore';
import { useFormContext } from 'react-hook-form';
import { showWarning } from '../../views/Select';
import useDataStore from '../../store/useDataStore';
import { useSettings } from '../../context/SettingsContext';
import sanitizeHtml from 'sanitize-html';
export default function ObjectListPicker(props) {
    var _a;
    if (typeof ((_a = props.config) === null || _a === void 0 ? void 0 : _a.showDescription) === 'undefined') {
        if (!props.config)
            props.config = {};
        props.config.showDescription = true;
    }
    const isGrouped = !!props.config.isGrouped;
    const theme = useTheme();
    const flow = useFlow();
    const { t, ts } = useI18N();
    const { widgetMode } = useSettings();
    const isDesktop = window.screen.width > 500;
    const isLarge = useMediaQuery(theme.breakpoints.up('sm'));
    const { setValue } = useFormContext();
    const [internalValue, setInternalValue] = useState(0);
    const { selectedResource, selectedApptype, selectedGroup, setSelectedApptype, setSelectedResource, setSelectedGroup, selectedCategory, selectedProduct, getSourceHelpers } = useWidgetStore();
    const { resources, apptypes } = useDataStore();
    useEffect(() => {
        var _a;
        if ((_a = props.config) === null || _a === void 0 ? void 0 : _a.resetSelection) {
            // reset everything, except the apptypes 
            // should we also reset capacity, if applicable?
            setSelectedResource(0);
            setSelectedGroup(0);
            setInternalValue(0);
        }
    }, []);
    useEffect(() => {
        var _a, _b, _c, _d, _e, _f, _g, _h;
        let sourceHelper = getSourceHelpers((_a = props.source) !== null && _a !== void 0 ? _a : 'apptype');
        if (sourceHelper.type && sourceHelper.options.length > 0) {
            let validObjects = sourceHelper.options.map((object) => object.id);
            if ((_b = props.config) === null || _b === void 0 ? void 0 : _b.showAnyOption) {
                validObjects.push(-1);
            }
            if (sourceHelper.type.length > 0) {
                // we already have a selection, make sure its still valid
                if (validObjects.includes(sourceHelper.type[0])) {
                    // setValue(props.source as string, sourceHelper.type[0])
                }
                else {
                    if (validObjects.length > 0) {
                        // not valid anymore, set it to the first option, if we have one
                        setValue(props.source, validObjects[0]);
                    }
                }
            }
            else if (sourceHelper.type.length === 0) {
                // there is no selection, but we have options loaded, handle first and false
                if ((_c = props.config) === null || _c === void 0 ? void 0 : _c.defaultValue) {
                    if (((_d = props.config) === null || _d === void 0 ? void 0 : _d.defaultValue) === 'first') {
                        setValue(props.source, sourceHelper.options[0].id);
                        sourceHelper.setter(sourceHelper.options[0].id);
                    }
                    else if (typeof ((_e = props.config) === null || _e === void 0 ? void 0 : _e.defaultValue) == 'number') {
                        if (validObjects.includes((_f = props.config) === null || _f === void 0 ? void 0 : _f.defaultValue)) {
                            // this also handles -1
                            setValue(props.source, (_g = props.config) === null || _g === void 0 ? void 0 : _g.defaultValue);
                        }
                        else {
                            // select the first option if the default option isnt available
                            setValue(props.source, validObjects[0]);
                        }
                    }
                }
                else if (((_h = props.config) === null || _h === void 0 ? void 0 : _h.defaultValue) === false) {
                    // explicitly select nothing
                    let currentOptions = validObjects.filter((option) => option !== -1);
                    if (currentOptions.length === 1) {
                        // if we have only 1 option left, select it
                        setValue(props.source, currentOptions[0]);
                    }
                }
            }
        }
    }, [selectedResource, selectedApptype, selectedCategory, selectedGroup, selectedProduct, resources, apptypes, props]);
    const handleClick = (e) => {
        var _a, _b, _c, _d, _e;
        if ((_a = props.config) === null || _a === void 0 ? void 0 : _a.isNavigator) {
            // @ts-ignore
            flow === null || flow === void 0 ? void 0 : flow.onNext();
        }
        else {
            let value = parseInt(e.target.closest('li').getAttribute('rel'));
            let sourceHelper = getSourceHelpers(props.source);
            if ((_b = props.config) === null || _b === void 0 ? void 0 : _b.multiSelect) {
                if ((_c = sourceHelper.type) === null || _c === void 0 ? void 0 : _c.includes(value)) {
                    (_d = sourceHelper.type) === null || _d === void 0 ? void 0 : _d.splice(sourceHelper.type.indexOf(value), 1);
                    let newValue = [...sourceHelper.type];
                    newValue.length > 1 ? sourceHelper.setterMulti(newValue) : sourceHelper.setter(newValue[0]);
                    value = newValue;
                }
                else {
                    let newValue = [...(_e = sourceHelper.type) !== null && _e !== void 0 ? _e : [], value];
                    if (props.config.maxSelect && props.config.maxSelect > 1) {
                        if (newValue.length > props.config.maxSelect) {
                            showWarning.value = ts('Je kunt maximaal %max% %max=1?onderdeel:onderdelen% selecteren.', { max: props.config.maxSelect });
                            newValue = sourceHelper.type;
                        }
                        else {
                            value = newValue;
                            showWarning.value = '';
                        }
                        //     console.log(newValue.length, props.config.maxSelect)
                    }
                    sourceHelper.setterMulti(newValue);
                    value = newValue;
                }
                if (value.includes(-1) && value.length > 1) {
                    // -1 is only a valid value if it's the only selected value
                    value.splice(value.indexOf(-1), 1);
                }
                setValue(props.source, value);
            }
            else {
                if (sourceHelper.type[0] === value) {
                    sourceHelper.setter(0);
                    value = 0;
                }
                else {
                    sourceHelper.setter(value);
                    setValue(props.source, [value]);
                }
            }
            setInternalValue(value);
        }
    };
    const renderComponents = useMemo(() => {
        var _a, _b, _c, _d, _e, _f, _g, _h;
        let active = (_a = selectedResource === null || selectedResource === void 0 ? void 0 : selectedResource.includes(-1)) !== null && _a !== void 0 ? _a : false;
        return (_jsx(Box, { sx: {
                minWidth: 120,
                my: isGrouped ? 1 : 0,
                maxWidth: isLarge ? '500px' : '100%',
                backgroundColor: theme.palette.background.paper,
            }, children: _jsxs(List, { sx: {
                    width: '100%',
                    borderTop: theme.palette.mode === 'dark' ? '#333 1px solid' : '#f1f1f1 1px solid',
                    paddingTop: 0
                }, children: [((_b = props.config) === null || _b === void 0 ? void 0 : _b.showAnyOption) && props.source === 'resource' && props.data.length > 1 && (_jsx(_Fragment, { children: _jsxs(ListItem, { dense: (_d = (_c = props === null || props === void 0 ? void 0 : props.config) === null || _c === void 0 ? void 0 : _c.dense) !== null && _d !== void 0 ? _d : false, onClick: handleClick, rel: "-1", sx: {
                                transition: 'background-color 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms,box-shadow 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms,border-color 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms,color 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms',
                                cursor: 'pointer',
                                paddingTop: 0,
                                my: 0,
                                boxShadow: 'none',
                                border: 'none',
                                borderBottom: theme.palette.mode === 'dark' ? '#333 1px solid' : '#f1f1f1 1px solid',
                                paddingY: 1,
                                alignItems: 'center',
                                backgroundColor: active
                                    ? theme.palette.primary.main
                                    : theme.palette.background.default,
                                color: active
                                    ? theme.palette.primary.contrastText
                                    : theme.palette.text.primary,
                                "& .MuiListItemText-secondary": {
                                    color: active
                                        ? theme.palette.primary.contrastText
                                        : theme.palette.text.primary,
                                },
                                "&:hover": {
                                    backgroundColor: active
                                        ? theme.palette.primary.main
                                        : (theme.palette.mode === 'dark'
                                            ? theme.palette.primary.light
                                            : theme.palette.primary.dark),
                                    color: theme.palette.primary.contrastText,
                                    "& .MuiListItemText-secondary": {
                                        color: theme.palette.primary.contrastText
                                    },
                                    "& .MuiChip-colorDefault": {
                                        backgroundColor: active
                                            ? theme.palette.primary.main
                                            : (theme.palette.mode === 'dark'
                                                ? theme.palette.primary.light
                                                : theme.palette.primary.dark),
                                        color: theme.palette.primary.contrastText,
                                        borderColor: theme.palette.primary.contrastText
                                    }
                                },
                            }, children: [((_e = props === null || props === void 0 ? void 0 : props.config) === null || _e === void 0 ? void 0 : _e.showImage) && (_jsx(ListItemAvatar, { children: _jsx(Avatar, { variant: (_g = (_f = props === null || props === void 0 ? void 0 : props.config) === null || _f === void 0 ? void 0 : _f.imageVariant) !== null && _g !== void 0 ? _g : 'circular', sx: {
                                            width: 56,
                                            height: 56,
                                            marginRight: 2,
                                            color: theme.palette.text.primary
                                        } }) })), _jsx(ListItemText, { sx: {
                                        "& .MuiListItemText-primary": {
                                            fontSize: ((_h = props === null || props === void 0 ? void 0 : props.config) === null || _h === void 0 ? void 0 : _h.dense) ? '1rem' : '1.25rem',
                                            fontWeight: '500'
                                        }
                                    }, primary: t("Geen voorkeur voor medewerker", 'select'), secondary: _jsx(Fragment, { children: _jsx(Typography, { component: "span", variant: "body2", sx: {
                                                display: 'inline'
                                            }, children: t('Alle beschikbaarheid wordt getoond.', 'select') }) }) })] }, -1) })), props.data && props.data.map && props.data.map((row, i) => {
                        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u, _v, _w, _x, _y;
                        if ((_c = (_b = (_a = props === null || props === void 0 ? void 0 : props.config) === null || _a === void 0 ? void 0 : _a.search) === null || _b === void 0 ? void 0 : _b.length) !== null && _c !== void 0 ? _c : 0 > 0) {
                            let search = (_d = props === null || props === void 0 ? void 0 : props.config) === null || _d === void 0 ? void 0 : _d.search;
                            if (!row.name.toUpperCase().includes(search.toUpperCase())) {
                                return (_jsx(Fragment, {}, i));
                            }
                        }
                        let sourceHelper = getSourceHelpers(props.source), active = (_f = (_e = sourceHelper.type) === null || _e === void 0 ? void 0 : _e.includes(row.id)) !== null && _f !== void 0 ? _f : false;
                        let price = new Intl.NumberFormat('nl-NL', { style: 'currency', currency: 'EUR' }).format(row.price).replace(',00', ',-'), duration = '';
                        if (!row.fixedPrice) {
                            price = ts('vanaf %price%', { price: price });
                        }
                        if ((row === null || row === void 0 ? void 0 : row.duration) > 0) {
                            let h = Math.floor((row === null || row === void 0 ? void 0 : row.duration) / 60);
                            duration = ts('%duration% minuten', { duration: row === null || row === void 0 ? void 0 : row.duration }, 'general');
                            if (h > 0) {
                                let m = (row === null || row === void 0 ? void 0 : row.duration) - (h * 60);
                                if (m > 0) {
                                    duration = ts('%hours% uur %minutes% minuten', { hours: h, minutes: m }, 'general');
                                }
                                else {
                                    duration = ts('%hours% uur', { hours: h }, 'general');
                                }
                            }
                        }
                        return (_jsxs(ListItem, { onClick: handleClick, rel: row.id, dense: (_h = (_g = props === null || props === void 0 ? void 0 : props.config) === null || _g === void 0 ? void 0 : _g.dense) !== null && _h !== void 0 ? _h : false, sx: Object.assign({ transition: 'background-color 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms,box-shadow 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms,border-color 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms,color 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms', cursor: 'pointer', paddingTop: 0, backgroundColor: theme.palette.background.default, color: theme.palette.text.primary, my: 0, boxShadow: 'none', border: 'none', borderBottom: theme.palette.mode === 'dark' ? '#333 1px solid' : '#f1f1f1 1px solid', paddingY: 1, alignItems: 'center' }, (((_j = props === null || props === void 0 ? void 0 : props.config) === null || _j === void 0 ? void 0 : _j.showImage) === true && {
                                backgroundColor: active
                                    ? theme.palette.primary.main
                                    : theme.palette.background.default,
                                color: active
                                    ? theme.palette.primary.contrastText
                                    : theme.palette.text.primary,
                                "&:hover": {
                                    backgroundColor: active
                                        ? theme.palette.primary.main
                                        : (theme.palette.mode === 'dark'
                                            ? theme.palette.primary.light
                                            : theme.palette.primary.dark),
                                    color: theme.palette.primary.contrastText,
                                    "& .MuiListItemText-secondary": {
                                        color: theme.palette.primary.contrastText
                                    },
                                    "& .MuiChip-colorDefault": {
                                        backgroundColor: active
                                            ? theme.palette.primary.main
                                            : (theme.palette.mode === 'dark'
                                                ? theme.palette.primary.light
                                                : theme.palette.primary.dark),
                                        color: theme.palette.primary.contrastText,
                                        borderColor: theme.palette.primary.contrastText
                                    }
                                },
                                "& .MuiListItemText-secondary": {
                                    transition: 'background-color 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms,box-shadow 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms,border-color 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms,color 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms',
                                    color: active
                                        ? theme.palette.primary.contrastText
                                        : theme.palette.text.primary,
                                }
                            })), children: [((_k = props === null || props === void 0 ? void 0 : props.config) === null || _k === void 0 ? void 0 : _k.showImage) && (_jsx(ListItemAvatar, { children: _jsx(Avatar, { variant: (_m = (_l = props === null || props === void 0 ? void 0 : props.config) === null || _l === void 0 ? void 0 : _l.imageVariant) !== null && _m !== void 0 ? _m : 'circular', src: row.image, sx: {
                                            width: 56,
                                            height: 56,
                                            marginRight: 2,
                                            color: theme.palette.text.primary
                                        }, children: props.source !== 'resource' && (_jsx(TableRowsIcon, {})) }) })), !((_o = props === null || props === void 0 ? void 0 : props.config) === null || _o === void 0 ? void 0 : _o.showImage) && (_jsxs(ListItemAvatar, { children: [!((_p = props === null || props === void 0 ? void 0 : props.config) === null || _p === void 0 ? void 0 : _p.multiSelect) && (_jsx(Radio, { checked: active, checkedIcon: _jsx(CheckCircleIcon, {}) })), ((_q = props === null || props === void 0 ? void 0 : props.config) === null || _q === void 0 ? void 0 : _q.multiSelect) && (_jsx(Radio, { checked: active, checkedIcon: _jsx(CheckCircleIcon, {}) })
                                        // <Checkbox checked={active} />
                                        )] })), _jsx(ListItemText, { sx: {
                                        "& .MuiListItemText-primary": {
                                            fontSize: ((_r = props === null || props === void 0 ? void 0 : props.config) === null || _r === void 0 ? void 0 : _r.dense) && row.description ? '1rem' : '1.25rem',
                                            fontWeight: 700
                                        }
                                    }, primary: row.name, secondary: _jsxs(Fragment, { children: [((((_s = props === null || props === void 0 ? void 0 : props.config) === null || _s === void 0 ? void 0 : _s.showPrice) && row.price > 0) || (((_t = props === null || props === void 0 ? void 0 : props.config) === null || _t === void 0 ? void 0 : _t.showDuration) && row.duration > 0)) && (_jsxs("span", { style: {
                                                    display: 'block'
                                                }, children: [((_u = props === null || props === void 0 ? void 0 : props.config) === null || _u === void 0 ? void 0 : _u.showPrice) && row.price > 0 && (_jsx(Chip, { variant: 'filled', component: 'span', label: price, sx: Object.assign({ marginRight: 1, marginBottom: 1 }, (((_v = props === null || props === void 0 ? void 0 : props.config) === null || _v === void 0 ? void 0 : _v.showImage) === true && {
                                                            color: active
                                                                ? theme.palette.primary.contrastText
                                                                : theme.palette.text.primary,
                                                            borderWidth: '1px',
                                                            borderStyle: 'solid',
                                                            borderColor: active
                                                                ? theme.palette.primary.contrastText
                                                                : 'transparent',
                                                            fontSize: '0.9rem',
                                                            height: 'auto',
                                                            "& span": {
                                                                paddingX: 1
                                                            }
                                                        })) })), ((_w = props === null || props === void 0 ? void 0 : props.config) === null || _w === void 0 ? void 0 : _w.showDuration) && row.duration > 0 && (_jsx(Chip, { variant: 'filled', component: 'span', label: duration, sx: Object.assign({ marginBottom: 1 }, (((_x = props === null || props === void 0 ? void 0 : props.config) === null || _x === void 0 ? void 0 : _x.showImage) === true && {
                                                            color: active ? theme.palette.primary.contrastText : theme.palette.text.primary,
                                                            borderWidth: '1px',
                                                            borderStyle: 'solid',
                                                            borderColor: active ? theme.palette.primary.contrastText : 'transparent',
                                                            fontSize: '0.9rem',
                                                            height: 'auto',
                                                            "& span": {
                                                                paddingX: 1
                                                            }
                                                        })) }))] })), _jsx(Typography, { component: "span", variant: "body2", sx: {
                                                    color: active ? theme.palette.primary.contrastText : theme.palette.text.primary,
                                                    display: 'inline'
                                                }, children: row.subtitle }), ((_y = props === null || props === void 0 ? void 0 : props.config) === null || _y === void 0 ? void 0 : _y.showDescription) && row.description && (_jsx(Typography, { component: "span", variant: "body2", sx: {
                                                    marginBottom: 1,
                                                    letterSpacing: '-0.75px'
                                                }, children: _jsx("div", { dangerouslySetInnerHTML: {
                                                        __html: sanitizeHtml(row.description, {
                                                            allowedTags: [
                                                                'b', 'strong',
                                                                'i', 'em',
                                                                'br'
                                                            ]
                                                        })
                                                    } }) }))] }) })] }, i));
                    })] }) }));
    }, [
        //`${selected}`, 
        internalValue,
        props.data,
        selectedApptype,
        // selectedCategory, 
        selectedGroup,
        // selectedProduct, 
        selectedResource
    ]);
    let _height = isDesktop
        ? (widgetMode === 'standalone'
            ? 'min(1000px, calc(100dvh - 201px))'
            : 'min(1000px,calc(100dvh - 98px))')
        : 'min(1000px, calc(100dvh - 82px))';
    // for now, fix the height set for the resource picker when images are enabled
    // make this generic at a later point
    return (_jsxs(_Fragment, { children: [(isGrouped || props.source === 'resource') && (_jsx(_Fragment, { children: renderComponents })), !isGrouped && props.source !== 'resource' && (_jsx(Box, { sx: {
                    height: _height,
                    minHeight: _height, // for iOS Safari and Edge
                    maxHeight: '1200px',
                    overflowY: 'scroll',
                    paddingBottom: '1em',
                    "&::-webkit-scrollbar": {
                        width: '4px',
                        height: '10px'
                    },
                    "&::-webkit-scrollbar-thumb": {
                        background: theme.palette.primary.main,
                        borderRadius: '1px'
                    },
                    "&::-webkit-scrollbar-track": {
                        background: 'transparent'
                    },
                    "&::-webkit-scrollbar-corner": {
                        background: 'transparent'
                    },
                }, children: _jsx(_Fragment, { children: renderComponents }) }))] }));
}
